import { create } from 'zustand';
import { adminSecurityGroupManagementApi } from '@api/api-config.ts';
import { AdminSecurityGroupResponse } from '@api/generated/portal-be-admin';

interface AdminSecurityGroupStoreState {
  loading: boolean;
  error: string | null;

  data: AdminSecurityGroupResponse[] | null;

  pagination: {
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
  };

  loadSecurityGroups: () => void;
}

export const useCreateAdminSecurityGroupStore = create<AdminSecurityGroupStoreState>((set, get) => ({
  loading: false,
  error: null,

  pagination: {
    page: 0,
    size: 20,
    totalElements: 0,
    totalPages: 0,
  },

  data: null,

  loadSecurityGroups: async () => {
    try {
      set({ loading: true, error: null });
      const { pagination } = get();

      const response = await adminSecurityGroupManagementApi.getSecurityGroups({ page: pagination.page, size: pagination.size });
      set({
        loading: false,
        error: null,
        pagination: {
          page: response.data.page,
          size: response.data.size,
          totalElements: response.data.total || 0,
          totalPages: response.data.totalPages || 0,
        },
        data: response.data.items,
      });
    } catch (error) {
      set({ loading: false, error: error instanceof Error ? error.message : 'Chyba při načítání' });
    }
  },
}));
